module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a9-6-89a664ca96fef404599e2c290da105f1.jpg";